import React from 'react';
import { __ } from '@wordpress/i18n';

// components
import AllBandiPreInstructorTableAsync from './components/AllBandiPreInstructorTableAsync';

const BandiPreInstructor = () => {
    return(
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Moduli attivi', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <AllBandiPreInstructorTableAsync/>
            </div>
        </div>
    )
}

export default BandiPreInstructor;